import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { animated, useSpring } from 'react-spring';

export const RevisitBadge = () => {
  const { t } = useTranslation();
  const ringingAnimation = useSpring({
    loop: true,
    from: { transform: 'rotate(5deg)' },
    to: [{ transform: 'rotate(0deg)' }],
    // duration: 3000,
    config: { tension: 2000, friction: 3 },
    reset: true,
  });

  return (
    <Tooltip
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      title="Der Fragebogen wurde aktualisiert und du musst ggf. einige deiner Antworten überprüfen"
    >
      <animated.div style={ringingAnimation} className="bg-danger-500 px-2 py-1 text-xs text-white rounded-lg">
        {t('components.ui.newbadge.newversion')}
      </animated.div>
    </Tooltip>
  );
};
